import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '@farm-portal/core/cart/cart.service';
import { AppConfigurationService } from 'farmcloud-core';
import { debounceTime, distinctUntilChanged, map, Observable, pairwise, skip, startWith, Subscription } from 'rxjs';

@Component({
  selector: 'app-cart-nav-item',
  templateUrl: 'cart-nav-item.component.html',
  styleUrls: ['cart-nav-item.component.scss']
})
export class CartNavItemComponent implements OnDestroy {
  public cartItemsCount$: Observable<number>;
  public isCartVisible = false;
  public animateCart = false;

  private sub?: Subscription;
  private badgeAnimationTimeout?: ReturnType<typeof setTimeout>;
  private readonly ANIMATION_DURATION_MS = 3000;

  constructor(
    private readonly cartService: CartService,
    private readonly router: Router,
    private readonly appConfig: AppConfigurationService
  ) {
    this.cartItemsCount$ = this.cartService.currentCart$.pipe(map(cart => cart.items.length));
    this.isCartVisible = this.areOrdersVisible();
    this.sub = this.cartItemsCount$
      .pipe(debounceTime(500), distinctUntilChanged(), startWith(0), pairwise(), skip(1))
      .subscribe(([prev, curr]) => {
        if (curr > prev && curr > 0) {
          this.triggerBadgeAnimation();
        }
      });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();

    if (this.badgeAnimationTimeout) {
      clearTimeout(this.badgeAnimationTimeout);
    }
  }

  public navigateToCart() {
    const returnUrl = this.router.url;
    return this.router.navigate(['shop-offers', 'cart'], {
      queryParams: { returnUrl }
    });
  }

  private triggerBadgeAnimation() {
    this.animateCart = true;

    if (this.badgeAnimationTimeout) {
      clearTimeout(this.badgeAnimationTimeout);
    }

    this.badgeAnimationTimeout = setTimeout(() => {
      this.animateCart = false;
    }, this.ANIMATION_DURATION_MS);
  }

  public areOrdersVisible() {
    return (
      this.appConfig.configuration.api_url.toLowerCase().includes('dev-api') ||
      this.appConfig.configuration.api_url.toLowerCase().includes('localhost')
    );
  }
}
